export enum Icons {
  None = '',
  ArrowUp = 'fa-solid fa-arrow-up-wide-short',
  ArrowLeft = 'fas fa-arrow-left',
  ArrowRight = 'fa-solid fa-arrow-right',
  ArrowsLeftAndRight = 'fa-solid fa-arrow-right-arrow-left',
  Bars = 'fa-solid fa-bars',
  Bolt = 'fa-solid fa-bolt',
  Briefcase = 'fa-solid fa-briefcase',
  Calendar = 'fa-solid fa-calendar',
  CircleCheck = 'fa-solid fa-circle-check',
  Clipboard = 'fa-solid fa-clipboard',
  CancelCircle = 'fa-solid fa-circle-xmark',
  InfoCircle = 'fa-solid fa-circle-info',
  List = 'fa-solid fa-list',
  PriceTag = 'fa-solid fa-tags',
  Edit = 'fas fa-edit',
  Store = 'fa-solid fa-store',
  WarningTriangle = 'fa-solid fa-triangle-exclamation',
  Plus = 'fa-solid fa-plus',
  Warning = 'fa-solid fa-warning',
  FileDownload = 'fa-solid fa-file-arrow-down',
  Checkmark = 'fa-solid fa-check',
  Pencil = 'fa-solid fa-pencil',
  Filter = 'fa-solid fa-filter',
  Boxes = 'fas fa-boxes',
  PenSquare = 'fas fa-pen-square',
  ExchangeAlt = 'fas fa-exchange-alt',
  ShoppingCart = 'fas fa-shopping-cart',
  UpRightFromSquare = 'fas fa-up-right-from-square',
  SortDown = 'fa-solid fa-arrow-down-wide-short',
  ChevronLeft = 'fas fa-chevron-left',
  ChevronRight = 'fas fa-chevron-right',
  Star = 'fas fa-star',
  Circle = 'fa-solid fa-circle',
  Stop = 'fa-solid fa-stop',
  LinkSlash = 'fa-solid fa-link-slash',
  Link = 'fa-solid fa-link',
  XMark = 'fa-solid fa-xmark',
  Search = 'fas fa-search',
  Bookmark = 'far fa-bookmark',
  Trash = 'fa-solid fa-trash',
  Sync = 'fas fa-sync'
}
